import { CmsContentType, CmsArticle, CmsContent } from '../interfaces/cms-interface';

export function isCmsArticle(content: CmsContent): content is CmsArticle {
  return content.contentType === CmsContentType.CMArticle;
}
